import React from 'react';
import { Route, Routes } from 'react-router-dom';
import {
  CONFIRM_ROUTE,
  LENDING_ROUTE,
  PURCHASE_ROUTE,
  SPPORT_ROUTE,
} from '../../constant/routes';
import { PurchasePage } from '../../page/PurchasePage';
import { LendingPage } from '../../page/LendingPage';
import { AutoConfirmPage } from '../../page/AutoConfirmPage';
import { LendingSuppportPage } from '../../page/LendingSupportPage';

declare global {
  interface Window {
    webkit?: any;
    AndroidInterface?: {
      videoViewed: (message: string) => void;
      readyToGet: (message: number) => void;
      themeSelected: (message: number) => void;
      endLecture: (message: number) => void;
      curPosition: (message: number) => void;
      authState: (message: number) => void;
    };
  }
}

export const App = () => {
  const readyToSend = () => {
    if (window.webkit && window.webkit.messageHandlers) {
      window.webkit?.messageHandlers?.readyToGet?.postMessage(1);
    }
    if (window.AndroidInterface) {
      window.AndroidInterface?.readyToGet(1);
    }
  };

  const sendAuthState = (auth: number) => {
    readyToSend();
    if (window.AndroidInterface) {
      window.AndroidInterface?.authState(auth);
    }
  };

  return (
    <div translate="no">
      <Routes>
        <Route path={LENDING_ROUTE} element={<LendingPage />} />
        <Route path={SPPORT_ROUTE} element={<LendingSuppportPage />} />
        <Route
          path={`${SPPORT_ROUTE}/:idSupport/:timestamp/:crc`}
          element={<LendingSuppportPage />}
        />
        <Route
          path={`${PURCHASE_ROUTE}/:userId`}
          element={<PurchasePage onChange={sendAuthState} />}
        />
        <Route
          path={`${PURCHASE_ROUTE}`}
          element={<PurchasePage onChange={sendAuthState} />}
        />
        <Route
          path={`${CONFIRM_ROUTE}/:lendingId/:appId`}
          element={<AutoConfirmPage />}
        />
      </Routes>
    </div>
  );
};

export default App;
